<template>
  <div class="container">
    <Header />
    <router-view :status.sync="isFooter" />
    <Footer v-if="isFooter" />
  </div>
</template>

<script>
import Header from "./header";
import Footer from "./footer";

export default {
  name: "Layout",
  components: {
    Header,
    Footer
  },
  data() {
    return {
      isFooter: true
    };
  }
};
</script>

<style lang="scss">
.container {
  padding-top: 90px;
}
.m-title {
  margin-bottom: 72px;
  h2 {
    font-size: 40px;
    color: #2f393f;
    line-height: 55px;
    text-align: center;
  }
  p {
    font-size: 17px;
    font-weight: 300;
    color: #818181;
    line-height: 24px;
    text-align: center;
    padding: 12px 0 8px;
    position: relative;
    text-transform: uppercase;
    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: -16px;
      transform: translate(-50%, 0);
      width: 64px;
      height: 4px;
      background: #f08300;
    }
  }
}
</style>
